import React from 'react';
// Data
import {
  dominationServicesArray,
  findomServicesArray,
  keyHoldingServicesArray,
  usedClothingArray,
  extrasArray,
  customFetishPicturesArray,
} from '../../utils/data/PricesData';

function PriceMenuComponent() {
  return (
    <section className='grid w-full'>
      <div className='grid gap-y-6 lg:container lg:mx-auto lg:max-w-[60vw]'>
        <section className='grid uppercase gap-y-12 lg:gap-y-16 lg:container lg:mx-auto lg:mt-12'>
          <ServiceSection
            title='Online Domination'
            items={dominationServicesArray}
          />
          <ServiceSection
            title='Financial Domination (Findom)'
            items={findomServicesArray}
          />
          <ServiceSection
            title='Key Holding & Chastity'
            items={keyHoldingServicesArray}
          />
          <ServiceSection
            title='Used Clothing & Worn Items'
            items={usedClothingArray}
          />
          <ServiceSection
            title='Custom Fetish Pictures'
            items={customFetishPicturesArray}
          />
          <ServiceSection title='Extras & Add-ons' items={extrasArray} />
        </section>
      </div>
    </section>
  );
}

function ServiceSection({ title, items }) {
  return (
    <article className='grid uppercase'>
      <section className='grid grid-cols-reg w-full gap-x-6'>
        <div>
          <h4 className='text-2xl lg:text-3xl neon_text_thin font-titleFont tracking-widest text-colour3 dark:text-colour3'>
            {title}
          </h4>
        </div>
        <div className='grid items-center'>
          <div className='h-[2px] bg-colour3'></div>
        </div>
      </section>
      <ul className='grid mt-4 space-y-2'>
        {items.map((item, index) => (
          <li key={index} className=''>
            <div className='grid grid-flow-col gap-2 justify-between'>
              <div className='grid'>
                <p>{item.label}</p>
              </div>
              <div className='grid text-end'>
                <p className=''>{item.price}</p>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </article>
  );
}

export default PriceMenuComponent;
